// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"2ef07a2f","423":"51c937c0","553":"dd9badbb","618":"24e9a498","664":"8f8fddee"}[chunkId] + ".css";
};